import { render, staticRenderFns } from "./LogoColori.vue?vue&type=template&id=16072668&scoped=true"
import script from "./LogoColori.vue?vue&type=script&lang=js"
export * from "./LogoColori.vue?vue&type=script&lang=js"
import style0 from "./LogoColori.vue?vue&type=style&index=0&id=16072668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16072668",
  null
  
)

export default component.exports